/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useState, useEffect, useRef } from "react";
import {
    CommandBarButton, Dropdown, IBasePickerProps, IBasePickerSuggestionsProps, IconButton, IDropdownOption,
    IMessageBarProps,
    IPersona, IPersonaProps, Label, mergeStyleSets, MessageBarType, TextField, ValidationState
} from '@fluentui/react';
import CircleLoader from '../../../Loader/CircleLoader/CircleLoader';
import { ILookupField, IChoiceField, IDestinatarioProtocollo, IField, ISendMailFields } from '../../../../shared/interfaces';
import AppUtilities from '../../../../shared/Utilities/appUtilities';
import { reduxActions, RootState } from '../../../../store';
import { store } from '../../../..';

import { useSelector } from 'react-redux';
import Utilities from '../../../../shared/Utilities/utilities';
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css"; // Add css for snow theme
import "../../../../assets/styles/quill-custom.css"; // Add css for snow theme
import ContactPanel from '../../../Contact/ContactPanel';
import AutocompleteContact from '../../../DynamicForm/Inputs/AutocompleteContact';
import abilityBuild from '../../../../shared/CASL/appAbility';
import { subject } from "@casl/ability";
import { toastRef } from '../../../Layout/Layout';
import contactsService from '../../../../services/contacts.service';
import { useBoolean } from '@fluentui/react-hooks';
import axios from 'axios';
import { Contact_Type } from '../../../../shared/enums';


const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    }
});

const emailRegex = Utilities.GetRegexIndirizziEmailSeparatiDaPuntoEVirgola();
const emailGlobalRegex = Utilities.GetGlobalRegexIndirizziEmailSeparatiDaPuntoEVirgola();

let cancelTokenSources = {};


export interface SendMailFormProps {
    extraCssClass?: string
    //onInputChangedHandler: (newField: IField) => void
    showMessageError: (errorMessageProps: IMessageBarProps) => void
    dismissMessageError: () => void

}
type Props = SendMailFormProps


const SendMailForm: React.FunctionComponent<Props> = (props) => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);

    const selectCurrentProtocol = (state: RootState) => state.appNavigationReducer.protocol;
    const currentProtocol = useSelector(selectCurrentProtocol);

    const selectSendMailFields = (state: RootState) => state.sendMailReducer.sendMailFields
    const sendMailFields = useSelector(selectSendMailFields);


    const selectContactPanelIsOpen = (state: RootState) => state.sendMailReducer.contactPanelIsOpen;
    const contactPanelIsOpen = useSelector(selectContactPanelIsOpen);

    const selectTargetFieldInternalNameOnAddContact = (state: RootState) => state.sendMailReducer.targetFieldInternalNameOnAddContact;
    const targetFieldInternalNameOnAddContact = useSelector(selectTargetFieldInternalNameOnAddContact);

    const selectPickerToKey = (state: RootState) => state.sendMailReducer.pickerToKey;
    const pickerToKey = useSelector(selectPickerToKey);

    const selectPickerCcKey = (state: RootState) => state.sendMailReducer.pickerCcKey;
    const pickerCcKey = useSelector(selectPickerCcKey);

    const [loading, { setTrue: showLoading, setFalse: hideLoading }] = useBoolean(false);

    const theme = 'snow';
    // const theme = 'bubble';

    const modules = {
        toolbar: [
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
        ],
    };


    const { quill, quillRef } = useQuill({ theme, modules });
    const [bodyValue, setBodyValue] = useState<string>()

    const contactsSuggestionProps: IBasePickerSuggestionsProps = {
        suggestionsHeaderText: 'Suggerimenti',
        mostRecentlyUsedHeaderText: 'Contatti suggeriti',
        noResultsFoundText: 'Nessun risultato trovato',
        loadingText: 'Caricamento',
        showRemoveButtons: false,

    };

    const sendMailFieldsRef = useRef(sendMailFields);

    useEffect(() => {
        //console.log("Effetto montato", sendMailFieldsRef.current);
        return () => {
            //console.log("Effetto smontato (cleanup)", sendMailFieldsRef.current);
            store.dispatch(reduxActions.sendMailActions.setInitialState());

        };
    }, []); // Il cleanup verr� eseguito quando il componente si smonta

    useEffect(() => {
        sendMailFieldsRef.current = sendMailFields;
    }, [sendMailFields]);

    useEffect(() => {
        setSendMailFields();
    }, [currentProtocol?.fields, currentAoo, currentUor, abilityBuild]);


    useEffect(() => {
        if (quill) {
            quill.on('text-change', function (delta, source) {
                setBodyValue(quill.root.innerHTML);
            })
        }
    }, [quill]);

    useEffect(() => {
        if (bodyValue && sendMailFields) {
            inputChanged({ ...sendMailFields.body, internalValue: bodyValue });
        }
    }, [bodyValue]);


    const inputChanged = (newField: IField) => {

        const updatedFields = { ...sendMailFieldsRef.current };
        updatedFields[newField.internalName] = { ...newField };
        store.dispatch(reduxActions.sendMailActions.updateState({ sendMailFields: { ...updatedFields } }));
    }




    const setSendMailFields = async () => {
        let currentSendMailFields = { ...sendMailFields };

        let fromField = { ...currentSendMailFields.from } as IChoiceField;
        let toField = { ...currentSendMailFields.to } as ILookupField;
        let ccField = { ...currentSendMailFields.cc } as ILookupField;
        let subjectField = { ...currentSendMailFields.subject };

        if (currentProtocol && currentAoo && abilityBuild && currentUor) {


            let mailboxes = currentUor?.mailboxesOut?.reduce((a: string[], o) => (o.mailbox.address && a.push(o.mailbox.address), a), [])

            let options: IDropdownOption[] = [];
            if (mailboxes) {
                props.dismissMessageError();

                mailboxes.forEach(el => {
                    if (el) {
                        options.push({ key: el, text: el });
                    }
                });
            } else {
                props.showMessageError({
                    dismissButtonAriaLabel: "Close",
                    messageBarType: MessageBarType.error,
                    children: "Nessuna cassetta configurata"
                });
            }

            let fromInternalValue: string = '';
            if (options.length === 1) {
                fromInternalValue = options[0].text;
            }

            // Se la segnatura � attiva ed � attiva la Rubrica
            if (abilityBuild.can('use', subject('IFeature', { key: 'Segnatura', enabled: true }))
                && abilityBuild.can('use', subject('IFeature', { key: 'Rubrica', enabled: true }))) {

                // imposto i field To e Cc in modo da:
                //      {1} mostrare il pulsante che permette di aprire la form per l'inserimento del contatto da utilizzare per la spedizione
                //      {2} controllare che il valore inserito abbia un indirizzo email valido
                //      {3} cercare i suggerimenti nella RubricaArxeia

                if (!toField.basePickerProps) {
                    let suggProps: IBasePickerSuggestionsProps = {
                        ...contactsSuggestionProps,
                    /*{1}*/ onRenderNoResultFound: () => onRenderNoResultFoundShowOpenContactPanelButton(toField.internalName)
                    }
                    toField.basePickerProps = {
                        pickerSuggestionsProps: suggProps,
                    /*{2}*/ onValidateInput: (input) => onValidateIndirizzoEmailPickerInput(toField.internalName, input),
                    /*{3}*/ onResolveSuggestions: filterContactsByText
                    } as IBasePickerProps<IPersonaProps>;
                }

                if (!ccField.basePickerProps) {
                    let suggProps: IBasePickerSuggestionsProps = {
                        ...contactsSuggestionProps,
                    /*{1}*/ onRenderNoResultFound: () => onRenderNoResultFoundShowOpenContactPanelButton(ccField.internalName)
                    }
                    ccField.basePickerProps = {
                        pickerSuggestionsProps: suggProps,
                    /*{2}*/ onValidateInput: (input) => onValidateIndirizzoEmailPickerInput(ccField.internalName, input),
                    /*{3}*/ onResolveSuggestions: filterContactsByText
                    } as IBasePickerProps<IPersonaProps>;
                }
            }
            else if (abilityBuild.can('use', subject('IFeature', { key: 'Rubrica', enabled: true }))) {

                // imposto i field To e Cc in modo da:
                //      {1} mostrare il pulsante che permette di aggiungere l'indirizzo email digitato
                //      {2} controllare che il valore inserito abbia un indirizzo email valido
                //      {3} cercare i suggerimenti nella RubricaArxeia
                //      {4} permettere di incollare pi� indirizzi email separati da uno spazio

                if (!toField.basePickerProps) {
                    let suggProps: IBasePickerSuggestionsProps = {
                        ...contactsSuggestionProps,
                    /*{1}*/ forceResolveText: "Aggiungi l'indirizzo digitato",
                    /*{1}*/ showForceResolve: () => true,
                    /*{1}*/ onRenderNoResultFound: () => <React.Fragment />
                    }
                    toField.basePickerProps = {
                        pickerSuggestionsProps: suggProps,
                                        /*{1}*/ createGenericItem: (input: string) => {
                            let tag = {
                                key: input,
                                text: input,
                                isGenericItem: true,
                                destinatarioProtocollo: { email: input }
                            }
                            return tag;
                        },

                    /*{2}*/ onValidateInput: (input) => onValidateIndirizzoEmailPickerInput(toField.internalName, input),
                    /*{3}*/ onResolveSuggestions: filterContactsByText,
                    /*{4}*/ inputProps: { onPaste: (e) => onPeoplePickerInputPaste(e, toField.internalName) }

                    } as IBasePickerProps<IPersonaProps>;
                }

                if (!ccField.basePickerProps) {
                    let suggProps: IBasePickerSuggestionsProps = {
                        ...contactsSuggestionProps,
                    /*{1}*/ forceResolveText: "Aggiungi l'indirizzo digitato",
                    /*{1}*/ showForceResolve: () => true,
                    /*{1}*/ onRenderNoResultFound: () => <React.Fragment />
                    }
                    ccField.basePickerProps = {
                        pickerSuggestionsProps: suggProps,
                    /*{1}*/ createGenericItem: (input: string) => {
                            let tag = {
                                key: input,
                                text: input,
                                isGenericItem: true,
                                destinatarioProtocollo: { email: input }
                            }
                            return tag;
                        },

                    /*{2}*/ onValidateInput: (input) => onValidateIndirizzoEmailPickerInput(ccField.internalName, input),
                    /*{3}*/ onResolveSuggestions: filterContactsByText,
                    /*{4}*/ inputProps: { onPaste: (e) => onPeoplePickerInputPaste(e, ccField.internalName) }
                    } as IBasePickerProps<IPersonaProps>;
                }
            }
            else {

                // altrimenti imposto i field To e Cc in modo da:
                //      {1} mostrare il pulsante che permette di aggiungere l'indirizzo email digitato
                //      {2} controllare che il valore inserito abbia un indirizzo email valido
                //      {3} inibire la ricerca di suggerimenti
                //      {4} permettere di incollare pi� indirizzi email separati da uno spazio


                if (!toField.basePickerProps) {
                    let suggProps: IBasePickerSuggestionsProps = {
                        ...contactsSuggestionProps,
                    /*{1}*/ forceResolveText: "Aggiungi l'indirizzo digitato",
                    /*{1}*/ showForceResolve: () => true,
                    /*{1}*/ onRenderNoResultFound: () => <React.Fragment />
                    }
                    toField.basePickerProps = {
                        pickerSuggestionsProps: suggProps,

                    /*{1}*/ createGenericItem: (input: string) => {
                            let tag = {
                                key: input,
                                text: input,
                                isGenericItem: true,
                                destinatarioProtocollo: { email: input }
                            }
                            return tag;
                        },
                    /*{2}*/ onValidateInput: (input) => onValidateIndirizzoEmailPickerInput(toField.internalName, input),
                    /*{3}*/ onResolveSuggestions: (searchValue: string): IPersona[] => [],
                    /*{4}*/ inputProps: { onPaste: (e) => onPeoplePickerInputPaste(e, toField.internalName) }

                    } as IBasePickerProps<IPersonaProps>;
                }

                if (!ccField.basePickerProps) {
                    let suggProps: IBasePickerSuggestionsProps = {
                        ...contactsSuggestionProps,
                    /*{1}*/ forceResolveText: "Aggiungi l'indirizzo digitato",
                    /*{1}*/ showForceResolve: () => true,
                    /*{1}*/ onRenderNoResultFound: () => <React.Fragment />
                    }
                    ccField.basePickerProps = {
                        pickerSuggestionsProps: suggProps,
                    /*{1}*/ createGenericItem: (input: string) => {
                            let tag = {
                                key: input,
                                text: input,
                                isGenericItem: true,
                                destinatarioProtocollo: { email: input }
                            }
                            return tag;
                        },
                    /*{2}*/ onValidateInput: (input) => onValidateIndirizzoEmailPickerInput(ccField.internalName, input),
                    /*{3}*/ onResolveSuggestions: (searchValue: string): IPersona[] => [],
                    /*{4}*/ inputProps: { onPaste: (e) => onPeoplePickerInputPaste(e, ccField.internalName) }

                    } as IBasePickerProps<IPersonaProps>;
                }
            }

            let oggettoProtocollo = currentProtocol.fields?.find(el => el.internalName === 'OggettoProtocollo');
            let subjectInternalValue = AppUtilities.FormatProtocolNumber(currentProtocol);
            if (oggettoProtocollo && oggettoProtocollo.internalValue) {
                subjectInternalValue += " - " + oggettoProtocollo.internalValue;
            }

            let toInternalValue: any[] = [];
            let destinatariEsterniIndex = currentProtocol.fields ? currentProtocol.fields.findIndex(el => el.internalName === 'DestinatarioEsterno') : -1;
            let caricaDestinatariDaRubrica: boolean = destinatariEsterniIndex !== undefined && destinatariEsterniIndex >= 0
                && abilityBuild.can('use', subject('IFeature', { key: 'Rubrica', enabled: true }));


            if (caricaDestinatariDaRubrica) {

                let destinatariEsterniField = currentProtocol.fields![destinatariEsterniIndex];
                if (destinatariEsterniField.controlType === 'autocompleteContact') {
                    let destinatariEst = destinatariEsterniField.internalValue ? [...destinatariEsterniField.internalValue] : [];

                    // mi assicuro che il destinatario abbia l'id numerico
                    let destinatariEstConId = destinatariEst.filter(el => !isNaN(el.key));

                    // se rimuovo qualche destinatario setto a true 
                    let isNotValid = destinatariEst.length !== destinatariEstConId.length;

                    if (destinatariEstConId.length > 0) {
                        showLoading();

                        await contactsService.getContactsInfoBatch(currentAoo!.id, 'Rubrica', destinatariEstConId.map(el => el.key))
                            .then(contacts => {
                                let destinatariEsterniFieldInternalValue: any[] = [];
                                contacts.forEach(contact => {

                                    destinatariEsterniFieldInternalValue.push(...AppUtilities.convertIContactToDestinatarioProtocolloTagArray(contact));
                                });

                                // se ho rimosso qualche destinatario senza id non serve aggiornare isNotValid
                                if (!isNotValid) {
                                    isNotValid = destinatariEsterniFieldInternalValue.some(el => !isDestinatarioValido(el.destinatarioProtocollo));
                                }

                                toInternalValue = [...destinatariEsterniFieldInternalValue
                                    //rimuovo i duplicati
                                    .filter((item, index, self) => index === self.findIndex((t) => t.key === item.key))
                                    //rimuovo gli indirizzi non validi
                                    .filter(el => isDestinatarioValido(el.destinatarioProtocollo))];


                                if (isNotValid) {

                                    toastRef.current?.show({ severity: 'warn', summary: 'Attenzione', detail: `Gli indirizzi non validi sono stati rimossi`, life: 5000, closable: false });
                                }

                                hideLoading();

                            })
                            .catch(error => {
                                hideLoading();
                                if (axios.isCancel(error)) {
                                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                                    console.log(error.message);
                                } else {
                                    throw error;
                                }
                            });

                    } else if (isNotValid) {

                        toastRef.current?.show({ severity: 'warn', summary: 'Attenzione', detail: `Gli indirizzi non validi sono stati rimossi`, life: 5000, closable: false });
                    }


                }
            }
            store.dispatch(reduxActions.sendMailActions.updateState({
                sendMailFields: {
                    ...sendMailFields,
                    from: { ...fromField, internalValue: fromInternalValue, options },
                    subject: { ...subjectField, internalValue: subjectInternalValue },
                    to: { ...toField, internalValue: [...toInternalValue] },
                    cc: { ...ccField }
                }
            }));

        }
    }

    const isDestinatarioValido = (destinatario: IDestinatarioProtocollo) => {
        if (!destinatario) {
            return false;
        }
        else if (!emailRegex.test(destinatario.email)) {
            return false;
        }
        else if (abilityBuild.can('use', subject('IFeature', { key: 'Segnatura', enabled: true }))) {
            switch (destinatario.tipologia) {
                case Contact_Type.Undefined:
                    return false;

                case Contact_Type.PersonaFisica:
                    if (!destinatario.nome || !destinatario.cognome) {
                        return false;
                    }
                    else {
                        return true;
                    }

                case Contact_Type.AmministrazioneEstera:
                case Contact_Type.PersonaGiuridica:
                    if (!destinatario.denominazione) {
                        return false;
                    }
                    else {
                        return true;
                    }

                case Contact_Type.Amministrazione:
                    if (!destinatario.denominazione || !destinatario.codiceIPA) {
                        return false;
                    }
                    else {
                        return true;
                    }
            }
        }
        else {
            return true;
        }


    }

    const onChangeTextFieldValue = (field, newValue?: string) => {

        if (field.maxLength && field.maxLength > 0) {
            if (newValue && newValue.length <= field.maxLength) {
                inputChanged({ ...field, internalValue: newValue });

            }
            else {
                inputChanged({ ...field });
            }
        }
        else inputChanged({ ...field, internalValue: newValue });
    }

    const onValidateIndirizzoEmailPickerInput = (fieldInternalName: string, input: string) => {
        if (input && emailRegex.test(input)) {
            return ValidationState.valid;
        }
        else {
            if (fieldInternalName === sendMailFields!.to.internalName) {
                store.dispatch(reduxActions.sendMailActions.setNextKeyPickerComponentTo());

            }
            else {
                store.dispatch(reduxActions.sendMailActions.setNextKeyPickerComponentCc());
            }

            toastRef.current?.show({ severity: 'warn', summary: 'Attenzione', detail: `${input} non \u00e8 un indirizzo email valido`, life: 5000, closable: false });
            return ValidationState.invalid
        }

    }

    let onDropDownSelectChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        inputChanged({ ...sendMailFields!.from, internalValue: option?.key })
    }

    let onCleanDropdownButton = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        inputChanged({ ...sendMailFields!.from, internalValue: null });
    }

    const onRenderSelectdOptionDropDown = (options: IDropdownOption<any>[] | undefined): JSX.Element => {
        const option = options![0];

        return (
            <div>
                <span>{option.text}
                    <IconButton
                        iconProps={{ iconName: 'Cancel' }}
                        styles={{ root: { height: 20, width: 20, verticalAlign: 'text-top' } }}
                        onClick={onCleanDropdownButton}
                    />
                </span>
            </div>
        );
    };

    const onRenderNoResultFoundShowOpenContactPanelButton = (targetFieldInternalName: string) => {

        return (
            <CommandBarButton
                iconProps={{ iconName: 'Add' }}
                styles={{
                    root: {
                        height: 30
                    }
                }}
                text="Aggiungi"
                onClick={() => {
                    if (targetFieldInternalName === sendMailFields!.to.internalName) {
                        store.dispatch(reduxActions.sendMailActions.setNextKeyPickerComponentTo());

                    }
                    else {
                        store.dispatch(reduxActions.sendMailActions.setNextKeyPickerComponentCc());
                    }


                    store.dispatch(reduxActions.sendMailActions.updateState({ contactPanelIsOpen: true, targetFieldInternalNameOnAddContact: targetFieldInternalName }))
                }}
            />
        );

    }

    let onAddContact = (destinatarioProtocollo: Partial<IDestinatarioProtocollo>) => {
        store.dispatch(reduxActions.sendMailActions.updateState({ contactPanelIsOpen: false }))
        let targetField = targetFieldInternalNameOnAddContact === sendMailFields!.to.internalName ? sendMailFields!.to : sendMailFields!.cc;

        let updatedValue: any[] = targetField!.internalValue ? [...targetField.internalValue] : [];
        let newContact = {
            key: destinatarioProtocollo.email,
            imageInitials: Utilities.GetInizialiFromUserName(destinatarioProtocollo.email),
            text: destinatarioProtocollo.email,
            hidePersonaDetails: false,
            destinatarioProtocollo
        };
        if (updatedValue.findIndex(el => el.key === newContact.key) < 0) {
            updatedValue.push(newContact);
        }
        inputChanged({ ...targetField!, internalValue: [...updatedValue] });

    }

    const filterContactsByText = async (filterText: string, currentTags?: IPersonaProps[]): Promise<IPersonaProps[]> => {

        let destinatariProtocolloInternalValue: any[] = [];
        if (currentAoo && filterText) {
            // se in cancelTokenSources c'� il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            let cancelTokenKey = contactsService.getContactSuggestions.name;
            cancelTokenSources[cancelTokenKey]?.cancel(`Request ${cancelTokenKey} annullata`);
            cancelTokenSources[cancelTokenKey] = axios.CancelToken.source();


            await contactsService.getContactSuggestions(currentAoo!.id, filterText.toLowerCase(), undefined, cancelTokenSources[cancelTokenKey].token)
                .then(suggestions => {
                    suggestions.forEach(contact => {
                        destinatariProtocolloInternalValue.push(...AppUtilities.convertIContactToDestinatarioProtocolloTagArray(contact));

                    })
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    }
                });
        }

        if (currentTags) {
            //Rimuovo eventuali elementi gi� selezionati
            destinatariProtocolloInternalValue = destinatariProtocolloInternalValue.filter(tag => currentTags.findIndex(el => el.key === tag.key) < 0);
        }

        destinatariProtocolloInternalValue = [...destinatariProtocolloInternalValue.filter(el => isDestinatarioValido(el.destinatarioProtocollo))];


        return destinatariProtocolloInternalValue;

    };

    const onAutocompleteContactChanged = (newField: IField) => {

        let autocompleteContactField = { ...newField } as ILookupField;
        let newInternalValue = [...autocompleteContactField.internalValue];

        let isValid = true;
        newInternalValue.forEach((el, elIndex) => {

            let destinatario = el.destinatarioProtocollo;
            if (!emailRegex.test(destinatario?.email)) {
                isValid = false;
            }
        });
        if (isValid) {
            inputChanged({ ...newField });
        }
        else {
            newInternalValue = newInternalValue.filter(el => emailRegex.test(el.destinatarioProtocollo.email))
            inputChanged({ ...newField, internalValue: [...newInternalValue] });

            toastRef.current?.show({ severity: 'warn', summary: 'Attenzione', detail: `Gli indirizzi non validi sono stati rimossi`, life: 5000, closable: false });
        }
    }

    const onPeoplePickerInputPaste = (ev: React.ClipboardEvent<HTMLInputElement>, fieldInternalName: string) => {

        let autocompleteContactField;
        if (fieldInternalName === sendMailFields!.to.internalName) {
            autocompleteContactField = sendMailFieldsRef.current!.to as ILookupField;
        }
        else {
            autocompleteContactField = sendMailFieldsRef.current!.cc as ILookupField;
        }
        let newInternalValue = [...autocompleteContactField.internalValue];
        let destinatariText = ev.clipboardData.getData('text');

        let array;

        let stopProtagation = false;
        while ((array = emailGlobalRegex.exec(destinatariText)) !== null) {
            let mail = array[0];
            if (newInternalValue.findIndex(el => el.key === mail) < 0) {
                newInternalValue.push({
                    key: array[0],
                    text: array[0],
                    destinatarioProtocollo: { email: mail }
                });
            }
            stopProtagation = true;

        }

        if (stopProtagation) {
            // se nel testo incollato c'� almeno un indirizzo email impedisco il paste e aggiungo gli indirizzi email aggiornando l'internal value
            ev.preventDefault();
            ev.stopPropagation();
        }
        inputChanged({ ...autocompleteContactField, internalValue: [...newInternalValue] });

    }




    return (

        <React.Fragment>
            <CircleLoader loaderClass='loader-large' loading={loading} />
            {contactPanelIsOpen &&
                <ContactPanel
                    contactPanelIsOpen={contactPanelIsOpen}
                    onContactDismiss={() => store.dispatch(reduxActions.sendMailActions.updateState({ contactPanelIsOpen: false }))}
                    onAddClick={onAddContact}
                    {...props}
                />
            }

            {sendMailFields &&
                sendMailFields.from.options.length > 1 &&
                <div className={classNames.inputWrapper}>
                    <div className={sendMailFields.from.touched && !sendMailFields.from.valid ? 'field error' : 'field'}>
                        <Label className='field-label' htmlFor={sendMailFields.from.internalName} required={sendMailFields.from.required}>{sendMailFields.from.displayName}</Label>

                        <Dropdown
                            key={sendMailFields.from.internalName}
                            disabled={false}
                            placeholder="Seleziona una cassetta"
                            options={sendMailFields.from.options as IDropdownOption[]}
                            selectedKey={sendMailFields.from.internalValue}
                            onChange={onDropDownSelectChange}
                            onRenderTitle={onRenderSelectdOptionDropDown}
                        />


                        {sendMailFields.from.touched && !sendMailFields.from.valid && <span className="error-message">Campo obbligatorio</span>}

                    </div >
                </div >
            }

            {sendMailFields &&
                <React.Fragment>

                    <AutocompleteContact {...props} key={`to${pickerToKey}`} field={sendMailFields.to} changed={onAutocompleteContactChanged} />


                    <AutocompleteContact {...props} key={`cc${pickerCcKey}`} field={sendMailFields.cc} changed={onAutocompleteContactChanged} />


                    <div className={classNames.inputWrapper}>
                        <div className={sendMailFields.subject.touched && !sendMailFields.subject.valid ? 'field error' : 'field'}>
                            <Label className='field-label' htmlFor={sendMailFields.subject.internalName} required={sendMailFields.subject.required}>{sendMailFields.subject.displayName}</Label>

                            <TextField
                                key={sendMailFields.subject.internalName}
                                value={sendMailFields.subject.internalValue}
                                onChange={(event, newValue) => onChangeTextFieldValue({ ...sendMailFields.subject }, newValue)}
                            />
                            {sendMailFields.subject.touched && !sendMailFields.subject.valid && <span className="error-message">Campo obbligatorio</span>}
                        </div>
                    </div>

                    <div className={classNames.inputWrapper}>
                        <div className={sendMailFields.body.touched && !sendMailFields.body.valid ? 'field error' : 'field'}>
                            <Label className='field-label' htmlFor={sendMailFields.body.internalName} required={sendMailFields.body.required}>{sendMailFields.body.displayName}</Label>

                            <div style={{ height: 300 }}>
                                <div ref={quillRef} />

                            </div>


                            {sendMailFields.body.touched && !sendMailFields.body.valid && <span className="error-message">Campo obbligatorio</span>}
                        </div>
                    </div>
                </React.Fragment>

            }

        </React.Fragment>

    );
};

export default SendMailForm;






//function useRef(sendMailFields: ISendMailFields) {
//    throw new Error('Function not implemented.');
//}
